<template>
  <CSidebar
    fixed
    breakpoint="lg"
    class="bg-style1 sidebar-fixed-position"
    :minimize="minimize"
    unfoldable
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CRenderFunction flat :contentToRender="navs"/>
  </CSidebar>
</template>

<script>
export default {
  name: 'TheSidebar',
  computed: {
    show() {
      return this.$store.state.sidebarShow
    },
    minimize() {
      return this.$store.state.sidebarMinimize
    },
    navs() {
      void this.$store.state.locale.lang
      return [{
        _name: 'CSidebarNav',
        _children: [
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.repairs'),
            to: '/supervisor/reportlist',
            icon: 'cil-window-restore'
          },
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.staff'),
            to: '/supervisor/UsersList',
            icon: 'cil-people'
          },
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.jobTypes'),
            to: '/supervisor/job-type',
            icon: 'cil-briefcase'
          },
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.dashboard'),
            to: '/supervisor/dashboard',
            icon: 'cil-speedometer'
          },
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.userManual'),
            to: '/supervisor/manual',
            icon: 'cil-book'
          }
        ]
      }]
    },
  },
}
</script>

<style scoped>
/* 1. สีพื้นหลัง Sidebar (Gradient) */
.bg-style1 {
  background: linear-gradient(30deg, #FFF0C4 0%, #145654 40%);
}

/* 2. จัดตำแหน่ง Sidebar: ให้เริ่มใต้ Header (60px) และสูงเต็มจอที่เหลือ */
.sidebar-fixed-position {
  top: 60px !important;       /* เว้นที่ด้านบนให้ Header */
  height: calc(100vh - 60px) !important; /* ความสูง = จอทั้งหมด - Header */
  z-index: 1020 !important;   /* อยู่ต่ำกว่า Header (Header = 1031) */
  position: fixed !important; /* เกาะติดหน้าจอ */
  box-shadow: 2px 0 5px rgba(0,0,0,0.1); /* เงาเล็กน้อยให้ดูมีมิติ */
}

/* 3. ตกแต่งปุ่มเมนู (เหมือนเดิมที่คุณชอบ) */
::v-deep .c-sidebar-nav-link {
  color: #ffffff;
  transition: all 0.25s ease;
  border-radius: 8px;
  margin: 4px 8px;
  position: relative;
  overflow: hidden;
}

::v-deep .c-sidebar-nav-link:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateX(4px);
}

::v-deep .c-sidebar-nav-link .c-sidebar-nav-icon {
  transition: transform 0.25s ease;
}

::v-deep .c-sidebar-nav-link:hover .c-sidebar-nav-icon {
  transform: scale(1.1);
}

::v-deep .c-sidebar-nav-link.c-active {
  background: rgba(255, 255, 255, 0.25);
  font-weight: 700;
}

::v-deep .c-sidebar-nav-link.c-active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 4px;
  border-radius: 4px;
  background: #ffd666;
}

::v-deep .c-sidebar-nav {
  animation: sidebarFadeIn 0.4s ease;
}

@keyframes sidebarFadeIn {
  from { opacity: 0; transform: translateX(-10px); }
  to { opacity: 1; transform: translateX(0); }
}
</style>

<style>
@media (max-width: 991.98px) {
  /* สั่งซ่อนฉากหลังสีดำ (Backdrop) ทิ้งไปเลย */
  .c-sidebar-backdrop {
    display: none !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }
}
</style>